<div class="page">
  <div class="title">{{ 'store.orders.title' | translate }}</div>
  <div class="orders-filters-container">
    <div class="inputs-container">
      <app-date-picker [from]="params.from" [to]="params['to']" (change)="getpickerValues($event)"></app-date-picker>
      <div class="search-container">
        <img src="assets/images/search.svg">
        <input
          [(ngModel)]="params.search"
          (keyup.enter)="doSearchByEnter($event);"
          (keyup)="doSearchByKeyUp($event);"
          [placeholder]="'store.orders.searchPlaceholder' | translate" type="text">
      </div>
      <app-select [selectedItem]="params.status" [options]="statusList"
                  (changeSelect)="changeFilter($event)"></app-select>
    </div>
    <div class="totals-container">
      <div class="totals-stats">
        <div class="value">{{stateCount}}</div>
        <div class="label">{{ 'store.orders.title' | translate }}</div>
      </div>
      <div class="totals-stats">
        <div  class="value"><span class="ltr-text">{{stateTotal | currency: stateCurrency: 'code'}}</span></div>
        <div class="label">{{ 'store.orders.total' | translate }}</div>
      </div>
    </div>

  </div>
  <div class="mobile-only mobile-table" *ngIf="dataList?.length">
    <div class="mobile-table__card" *ngFor="let item of dataList; let i = index">
      <div class="mobile-table__header">
        <div>
          <div class="mobile-table__title">{{item.voucherName}}</div>
          <div  class="mobile-table__meta"><span class="ltr-text">{{item.createdDate | date: 'hh:mm, d MMMM y'}}</span></div>
        </div>
        <div class="mobile-table__actions">
          <button
            class="mobile-table__action-btn"
            [placement]="'bottom'"
            [outsideClick]="true"
            [popover]="popTemplateMobile"
            [attr.aria-label]="'common.actions' | translate"
          >
            <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
          </button>
          <ng-template #popTemplateMobile>
            <div class="mobile-table__menu-item" (click)="goToDetails(item.id)">{{ 'common.viewDetails' | translate }}</div>
          </ng-template>
        </div>
      </div>
      <div class="mobile-table__rows">
        <div class="mobile-table__row">
          <div class="mobile-table__label">{{ 'store.orders.table.voucherCode' | translate }}</div>
          <div class="mobile-table__value">
            <span *ngIf="item.status === 'ACTIVE'">—</span>
            <span *ngIf="item.status !== 'ACTIVE'">{{item.code}}</span>
          </div>
        </div>
        <div class="mobile-table__row">
          <div class="mobile-table__label">{{ 'store.orders.table.purchasedBy' | translate }}</div>
          <div class="mobile-table__value">{{item.purchasedBy}}</div>
        </div>
        <div class="mobile-table__row">
          <div class="mobile-table__label">{{ 'common.status' | translate }}</div>
          <div class="mobile-table__value">
            <div *ngIf="item.status === 'ACTIVE'" [class]="'PURCHASED'">{{ 'store.orders.status.purchased' | translate }}</div>
            <div *ngIf="item.status !== 'ACTIVE'" [class]="item.status">{{item?.status}}</div>
          </div>
        </div>
        <div class="mobile-table__row">
          <div class="mobile-table__label">{{ 'store.orders.table.voucherValue' | translate }}</div>
          <div class="mobile-table__value">{{item.voucherValue}}</div>
        </div>
        <div class="mobile-table__row">
          <div class="mobile-table__label">{{ 'store.orders.table.price' | translate }}</div>
          <div class="mobile-table__value">{{item.price}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="empty-list mobile-only" *ngIf="!dataList?.length">{{ 'store.orders.empty' | translate }}</div>
  <div class="table-wrapper desktop-only">
    <table class="table AgentsTable">
      <thead>
      <tr>
        <th>{{ 'common.date' | translate }}</th>
        <th>{{ 'store.orders.table.voucherName' | translate }}</th>
        <th>{{ 'store.orders.table.voucherCode' | translate }}</th>
        <th>{{ 'store.orders.table.purchasedBy' | translate }}</th>
        <th>{{ 'common.status' | translate }}</th>
        <th>{{ 'store.orders.table.voucherValue' | translate }}</th>
        <th>{{ 'store.orders.table.price' | translate }}</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of dataList; let i = index">
        <td ><span class="ltr-text">{{item.createdDate | date: 'hh:mm, d MMMM y'}}</span></td>
        <td>{{item.voucherName}}</td>
        <td>
          <div *ngIf="item.status === 'ACTIVE'" class="empty-code"></div>
          <div *ngIf="item.status !== 'ACTIVE'">
            {{item.code}}
          </div>
        </td>
        <td>{{item.purchasedBy}}</td>
        <td>
          <div *ngIf="item.status === 'ACTIVE'" style="margin-right: auto; margin-left: auto" [class]="'PURCHASED'">
            {{ 'store.orders.status.purchased' | translate }}
          </div>
          <div *ngIf="item.status !== 'ACTIVE'" style="margin-right: auto; margin-left: auto"
               [class]="item.status">{{item?.status}}</div>
        </td>
        <td>{{item.voucherValue}}</td>
        <td>{{item.price}}</td>

        <td class="dots-container">
          <button
            [placement]="'left'"
            [outsideClick]="true"
            [popover]="popTemplate"
          >
            <i
              class="fa fa-ellipsis-h" aria-hidden="true"></i>
          </button>

          <ng-template #popTemplate>
            <div class="mobile-table__menu-item" (click)="goToDetails(item.id)"> {{ 'common.viewDetails' | translate }}
            </div>
          </ng-template>
        </td>
      </tr>
      </tbody>

    </table>
    <div class="empty-list" *ngIf="!dataList?.length">{{ 'store.orders.empty' | translate }}</div>

  </div>
  <div class="table-footer">
    <app-pagination [totalPages]="totalPages" [currentPage]="params?.page" (backClicked)="backClick($event)"
                    (nextClicked)="nextClick($event)"></app-pagination>
    <app-export-csv [disabled]="!dataList?.length" path="web/orders/csv" [params]="params"></app-export-csv>
  </div>
  <ngx-spinner color="rgba(30, 205, 100, 1)" type="ball-scale-multiple"></ngx-spinner>
</div>



